import { i18 } from '../../utilities/i18';
import { ClientSegmentConstants } from './clientSegmentConstants';

export const clientSegments = {
    APARTMENT: {
        value: ClientSegmentConstants.APARTMENT,
        label: i18.ServicesFormEdit.Labels.ServiceDetailsApartmentSegment
    },
    ADMINISTRATOR: {
        value: ClientSegmentConstants.ADMINISTRATOR,
        label: i18.ServicesFormEdit.Labels.ServiceDetailsAdministratorSegment
    },
    EShop: {
        value: ClientSegmentConstants.EShop,
        label: i18.ServicesFormEdit.Labels.ServiceDetailsEShopSegment
    },
    Retailer: {
        value: ClientSegmentConstants.Retailer,
        label: i18.ServicesFormEdit.Labels.ServiceDetailsRetailerSegment
    },
    Insurance: {
        value: ClientSegmentConstants.Insurance,
        label: i18.ServicesFormEdit.Labels.ServiceDetailsInsuranceSegment
    },
    FM: {
        value: ClientSegmentConstants.FM,
        label: i18.ServicesFormEdit.Labels.ServiceDetailsFMSegment
    },
    Community: {
        value: ClientSegmentConstants.Community,
        label: i18.ServicesFormEdit.Labels.ServiceDetailsCommunitySegment
    },
    RealEstate: {
        value: ClientSegmentConstants.RealEstate,
        label: i18.ServicesFormEdit.Labels.ServiceDetailsRealEstateSegment
    },
    Segment1: {
        value: ClientSegmentConstants.Segment1,
        label: i18.ServicesFormEdit.Labels.ServiceDetailsSegment1Segment
    },
    Segment2: {
        value: ClientSegmentConstants.Segment2,
        label: i18.ServicesFormEdit.Labels.ServiceDetailsSegment2Segment
    },
    Segment3: {
        value: ClientSegmentConstants.Segment3,
        label: i18.ServicesFormEdit.Labels.ServiceDetailsSegment3Segment
    },
};
